// extracted by css-extract-rspack-plugin
export default {"NewRulesetButton":"InsightsBlank-module__NewRulesetButton__zLRL14n"};